var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-entry"},[_c(_vm.isEmpty ? 'FileUpload' : 'FileAuth',{ref:"component",tag:"component",attrs:{"form":_vm.form,"config":_vm.config,"main":_vm.main,"properties":_vm.properties},on:{"uploaded":_vm.onUploaded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }